import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  userPhone: string = null;
  timer = 0;
}
